import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import { TextField, FormControl, MenuItem, Select, Checkbox, Button  } from '@mui/material'

const useStyles = makeStyles((theme)=>({
  box: {
    margin:'0 auto',
    maxWidth:'1800px',
    padding:'0 20px',

    fontFamily:[
      'Noto Sans KR'
    ],
  },
  boardEditBlockkH1:{
    padding:'40px 0 20px 10px',
    fontWeight:'700',
    fontSize:'22px',
  },
  innerDiv:{
    margin:'20px 0',
    display:'flex',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
    }
  },
  spanSpan:{
    fontSize:'18px',
    fontWeight:'500',
    width:'100px',

    [theme.breakpoints.down(1025)]: {
      marginBottom:'10px',
      textAlign:'center'
    }
  },
  textFieldDiv:{
    marginLeft:'10px',

    [theme.breakpoints.down(1025)]: {
      marginBottom:'10px'
    }
  },

}));

const BoardEdit = () => {

  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <div className={classes.boardEditBlock}>
      <div className={classes.box}>
        <h1 className={classes.boardEditBlockkH1}>게시판 수정</h1>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>테이블</span>
          <div className={classes.textFieldDiv}>
            <TextField 
              sx={{ width: 300 }}
              hiddenlabel="true" 
              variant="outlined" 
            />
          </div>
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>그룹</span>
          <div className={classes.textFieldDiv}>
            <FormControl >
              <Select
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                style={{ width: 300 }}
              >
                <MenuItem value={0}>0</MenuItem>
                <MenuItem value={1}>1</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>게시판제목</span>
          <div className={classes.textFieldDiv}>
            <TextField 
              sx={{ width: 300 }}
              hiddenlabel="true" 
              variant="outlined" 
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default BoardEdit
